module.exports = __webpack_public_path__ + "static/media/communication.3a267a2d.svg";